module.exports = __webpack_public_path__ + "static/img/xjrmyy.438e3d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/xjrmyy.png
// module id = f8FA
// module chunks = 0